import React, {
  useEffect,
  useState
} from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/contact-page.css";
import contactImage from "../assets/images/images.jpg";
import api from "../api/Api.js";

// ============================================================
// CONTACT PAGE
// Original HTML design converted to React
// Dynamic CAPTCHA + API submission preserved
// ============================================================

const ContactPage = () => {

  // ==========================================================
  // FORM STATE
  // ==========================================================

  const [formData, setFormData] = useState({
    txtName: "",
    txtemail: "",
    txtTelephoneNo: "",
    txacomments: "",
    txtCode: ""
  });


  // ==========================================================
  // CAPTCHA
  // ==========================================================

  const [captcha, setCaptcha] = useState("");
  const [captchaLoading, setCaptchaLoading] = useState(false);


  // ==========================================================
  // SUBMIT STATE
  // ==========================================================

  const [submitting, setSubmitting] = useState(false);


  // ==========================================================
  // MESSAGE
  // ==========================================================

  const [message, setMessage] = useState({
    type: "",
    text: ""
  });


  // ==========================================================
  // CONTACT CONTENT
  // Same content as original HTML
  // ==========================================================

  const contact = {

    contact_title: "CONTACT US",

    contact_heading: "Get touch with us",

    address_title: "Contact Adress:",

    company_name: "Crete Holidays",

    address:
      "El. Venizelou 20, Hersonissos 70014, Crete, Greece",

    whatsapp_label: "WhatsApp:",

    whatsapp_number: "+31- 97010204725",

    whatsapp_hours: "(during office hours)",

    email_label: "Email:",

    email: "info@crete-holidays.net",

    form_title: "Contact form :",

    name_label: "Name :",

    email_label_form: "Email Adress :",

    telephone_label: "Telephone Number :",

    comments_label: "Your Comments / Questions :",

    captcha_label: "Code (Case Sensitive) :",

    submit_button: "SEND"
  };


  // ==========================================================
  // LOAD CAPTCHA
  // ==========================================================

  const loadCaptcha = async () => {

    try {

      setCaptchaLoading(true);

      const response = await api.get(
        "/contact/captcha"
      );

      console.log(
        "CAPTCHA RESPONSE:",
        response.data
      );

      if (
        response.data &&
        response.data.success
      ) {

        setCaptcha(
          response.data.captcha
        );

      } else {

        setCaptcha("");

        setMessage({
          type: "danger",
          text:
            response.data?.message ||
            "Unable to load captcha."
        });

      }

    } catch (error) {

      console.error(
        "CAPTCHA LOAD ERROR:",
        error
      );

      setCaptcha("");

      setMessage({
        type: "danger",
        text:
          "Unable to load captcha. Please try again."
      });

    } finally {

      setCaptchaLoading(false);

    }

  };


  // ==========================================================
  // LOAD CAPTCHA WHEN PAGE LOADS
  // ==========================================================

  useEffect(() => {

    loadCaptcha();

  }, []);


  // ==========================================================
  // HANDLE INPUT CHANGE
  // ==========================================================

  const handleChange = (e) => {

    const {
      name,
      value
    } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

  };


  // ==========================================================
  // SUBMIT FORM
  // ==========================================================

  const handleSubmit = async (e) => {

    e.preventDefault();

    // Clear old message

    setMessage({
      type: "",
      text: ""
    });


    // ========================================================
    // VALIDATION
    // ========================================================

    if (
      !formData.txtName.trim() ||
      !formData.txtemail.trim() ||
      !formData.txacomments.trim() ||
      !formData.txtCode.trim()
    ) {

      setMessage({
        type: "danger",
        text:
          "Please fill all required fields."
      });

      return;

    }


    setSubmitting(true);


    try {

      // ======================================================
      // SEND FORM DATA
      // ======================================================

      const response = await api.post(
        "/contact/submit",
        formData
      );


      console.log(
        "CONTACT SUBMIT RESPONSE:",
        response.data
      );


      // ======================================================
      // SUCCESS
      // ======================================================

      if (
        response.data &&
        response.data.success
      ) {

        setMessage({
          type: "success",
          text:
            response.data.message ||
            "Your message has been submitted successfully."
        });


        // ====================================================
        // CLEAR FORM
        // ====================================================

        setFormData({
          txtName: "",
          txtemail: "",
          txtTelephoneNo: "",
          txacomments: "",
          txtCode: ""
        });


        // ====================================================
        // LOAD NEW CAPTCHA
        // ====================================================

        await loadCaptcha();

      } else {

        setMessage({
          type: "danger",
          text:
            response.data?.message ||
            "Unable to submit your message."
        });


        // ====================================================
        // NEW CAPTCHA AFTER ERROR
        // ====================================================

        await loadCaptcha();


        setFormData((prev) => ({
          ...prev,
          txtCode: ""
        }));

      }

    } catch (error) {

      console.error(
        "CONTACT SUBMIT ERROR:",
        error
      );


      setMessage({
        type: "danger",
        text:
          error.response?.data?.message ||
          "Unable to send your message. Please try again."
      });


      // ====================================================
      // RELOAD CAPTCHA
      // ====================================================

      await loadCaptcha();


      setFormData((prev) => ({
        ...prev,
        txtCode: ""
      }));

    } finally {

      setSubmitting(false);

    }

  };


  // ==========================================================
  // PAGE
  // ==========================================================

  return (

    <div className="contact-content-only">


      {/* ====================================================
          ORIGINAL HTML IMAGE

          Original:
          <img src="images/images.jpg" style="width:100%">
      ==================================================== */}

      <img
        src={contactImage}
        className="contact-main-image"
        alt="Crete Holidays"
      />


      <div className="clearfix"></div>


      {/* ====================================================
          CONTACT SECTION
      ==================================================== */}

      <div className="ft-bg">

        <div className="why-choose-us-area">

          <div className="container">

            <div className="row">


              {/* ==================================================
                  PAGE TITLE
              ================================================== */}

              <div
                className="col-md-12"
                align="center"
              >

                <div className="heading-section heading-section-white">

                  <p className="contact-title">
                    {contact.contact_title}
                  </p>

                  <h2 className="aboutp contact-heading">
                    {contact.contact_heading}
                  </h2>

                </div>

              </div>


              {/* ==================================================
                  LEFT COLUMN
              ================================================== */}

              <div
                className="col-md-4 contact-left-column"
              >

                <div className="services-2 w-100">

                  <div className="pr28 text-1 text w-100">

                    <div className="price-card contact-price-card">


                      {/* ==================================================
                          LEFT CARD TITLE
                      ================================================== */}

                      <div className="content">

                        <h2>

                          Contact{" "}

                          <span>
                            Adress:
                          </span>

                        </h2>

                      </div>


                      {/* ==================================================
                          COMPANY
                      ================================================== */}

                      <p>

                        <strong>
                          {contact.company_name}
                        </strong>

                      </p>


                      {/* ==================================================
                          ADDRESS
                      ================================================== */}

                      <p>

                        El. Venizelou 20, Hersonissos 70014,
                        <br />
                        Crete, Greece

                      </p>


                      {/* ==================================================
                          WHATSAPP
                      ================================================== */}

                      <p>

                        <strong>
                          {contact.whatsapp_label}
                        </strong>

                        {" "}

                        <a
                          href={`https://wa.me/${contact.whatsapp_number.replace(
                            /\D/g,
                            ""
                          )}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {contact.whatsapp_number}
                        </a>

                        <br />

                        {contact.whatsapp_hours}

                      </p>


                      {/* ==================================================
                          EMAIL
                      ================================================== */}

                      <p>

                        <strong>
                          {contact.email_label}
                        </strong>

                        {" "}

                        <a
                          href={`mailto:${contact.email}`}
                        >
                          {contact.email}
                        </a>

                      </p>


                      <div className="clearfix"></div>

                    </div>

                  </div>

                </div>

              </div>


              {/* ==================================================
                  RIGHT COLUMN
              ================================================== */}

              <div
                className="col-md-8 contact-right-column"
              >

                <div className="pr28 services services-2 w-100">


                  {/* ==================================================
                      ORIGINAL b1 BORDER
                  ================================================== */}

                  <div className="b1 price-card1 contact-form-card">


                    {/* ==================================================
                        FORM TITLE
                    ================================================== */}

                    <div className="content">

                      <h2>

                        Contact{" "}

                        <span>
                          form :
                        </span>

                      </h2>

                    </div>


                    {/* ==================================================
                        SUCCESS / ERROR MESSAGE
                    ================================================== */}

                    {message.text && (

                      <div
                        className={`alert alert-${message.type} contact-message`}
                      >
                        {message.text}
                      </div>

                    )}


                    {/* ==================================================
                        FORM
                    ================================================== */}

                    <form
                      method="post"
                      id="frmContact"
                      name="frmContact"
                      onSubmit={handleSubmit}
                      autoComplete="off"
                    >

                      <div className="clearfix"></div>


                      <div className="contact-form-container">


                        {/* ==================================================
                            NAME
                        ================================================== */}

                        <div
                          className="contact-field contact-field-name"
                        >

                          <strong>
                            {contact.name_label}
                          </strong>

                          <br />

                          <input
                            name="txtName"
                            id="txtName"
                            type="text"
                            className="form-control"
                            value={formData.txtName}
                            onChange={handleChange}
                            maxLength={100}
                            required
                          />

                        </div>


                        {/* ==================================================
                            EMAIL
                        ================================================== */}

                        <div
                          className="contact-field contact-field-email"
                        >

                          <strong>
                            {contact.email_label_form}
                          </strong>

                          <br />

                          <input
                            name="txtemail"
                            id="txtemail"
                            type="email"
                            className="form-control"
                            value={formData.txtemail}
                            onChange={handleChange}
                            maxLength={100}
                            required
                          />

                        </div>


                        {/* ==================================================
                            TELEPHONE
                        ================================================== */}

                        <div
                          className="contact-field contact-field-phone"
                        >

                          <strong>
                            {contact.telephone_label}
                          </strong>

                          <br />

                          <input
                            name="txtTelephoneNo"
                            id="txtTelephoneNo"
                            type="text"
                            className="form-control"
                            value={formData.txtTelephoneNo}
                            onChange={handleChange}
                            maxLength={15}
                          />

                        </div>


                        {/* ==================================================
                            COMMENTS
                        ================================================== */}

                        <div
                          className="contact-field contact-field-comments"
                        >

                          <strong>
                            {contact.comments_label}
                          </strong>

                          <br />

                          <textarea
                            name="txacomments"
                            id="txacomments"
                            cols="29"
                            rows="3"
                            className="form-control"
                            value={formData.txacomments}
                            onChange={handleChange}
                            required
                          />

                        </div>


                        {/* ==================================================
                            CAPTCHA
                        ================================================== */}

                        <div
                          className="contact-field contact-field-captcha"
                        >

                          <strong>
                            {contact.captcha_label}
                          </strong>

                          <br />


                          {/* ==================================================
                              CAPTCHA INPUT
                          ================================================== */}

                          <input
                            name="txtCode"
                            type="text"
                            className="form-control"
                            id="txtCode"
                            maxLength={5}
                            value={formData.txtCode}
                            onChange={handleChange}
                            required
                          />


                          {/* ==================================================
                              CAPTCHA DISPLAY
                          ================================================== */}

                          <div className="contact-captcha-container">

                            <div className="contact-captcha-image">

                              {captchaLoading ? (

                                <span>
                                  Loading...
                                </span>

                              ) : (

                                <span className="captcha-text">
                                  {captcha || "-----"}
                                </span>

                              )}

                            </div>


                            {/* ==================================================
                                CAPTCHA REFRESH
                            ================================================== */}

                            <button
                              type="button"
                              className="contact-captcha-refresh"
                              onClick={loadCaptcha}
                              disabled={captchaLoading}
                              title="Refresh captcha"
                            >
                              ↻
                            </button>

                          </div>


                          {/* ==================================================
                              SEND BUTTON
                          ================================================== */}

                          <input
                            name="btnSubmit"
                            id="btnSubmit"
                            type="submit"
                            className="btn btn-secondary1 py-3 px-4 contact-submit"
                            value={
                              submitting
                                ? "SENDING..."
                                : contact.submit_button
                            }
                            disabled={submitting}
                          />

                        </div>

                      </div>


                      <div className="clearfix"></div>

                    </form>


                    <div className="clearfix"></div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>


    </div>

  );

};

export default ContactPage;